import api from '../../../../api/client'

const ALL_KEYS = [
  'institutes',
  'branches',
  'courses',
  'courses_previous',
  'batches',
  'schemes',
  'sources',
  'counsellors',
  'academic_years',
  'subjects',
  'caste',
  'subcaste',
  'language',
  'religions',
  'relations',
  'occupations',
  'states',
  'places',
  'schools',
  'boards',
  'mediums',
  'classrooms',
  'departments',
]

const cache = {}
const itemsCache = {}

/**
 * Fetch raw option string array from backend admission masters endpoint
 * which delegates to the active tenant's real master tables.
 */
export async function getMasterOptions(key) {
  if (cache[key] && cache[key].length > 0) return cache[key]
  try {
    const { data } = await api.get(`/admission/masters/${key}`)
    const options = (data && data.options) || []
    if (Array.isArray(options) && options.length > 0) {
      cache[key] = options
      if (Array.isArray(data.items)) {
        itemsCache[key] = data.items
      }
      return options
    }
  } catch (err) {
    console.error(`Failed to load options for ${key}:`, err)
  }
  return cache[key] || []
}

/**
 * Fetch structured option item array [{ id, name }] for master lookups
 */
export async function getMasterOptionItems(key) {
  if (itemsCache[key] && itemsCache[key].length > 0) return itemsCache[key]
  try {
    const { data } = await api.get(`/admission/masters/${key}`)
    if (data && Array.isArray(data.items) && data.items.length > 0) {
      itemsCache[key] = data.items
      if (Array.isArray(data.options)) {
        cache[key] = data.options
      }
      return data.items
    }
  } catch (err) {
    console.error(`Failed to load option items for ${key}:`, err)
  }
  return itemsCache[key] || []
}

/**
 * Load multiple master option items in parallel and return a map
 */
export async function loadMasterOptionItems(keys = ALL_KEYS) {
  const results = {}
  await Promise.all(
    keys.map(async (key) => {
      results[key] = await getMasterOptionItems(key)
    })
  )
  return results
}

/**
 * Load multiple master options in parallel and return a map
 */
export async function loadMasterOptions(keys = ALL_KEYS) {
  const results = {}
  await Promise.all(
    keys.map(async (key) => {
      results[key] = await getMasterOptions(key)
    })
  )
  return results
}

/**
 * Invalidate in-memory options cache (e.g. after creating a new master)
 */
export function invalidateMasterOptionsCache(key) {
  if (key) {
    delete cache[key]
    delete itemsCache[key]
  } else {
    Object.keys(cache).forEach((k) => delete cache[k])
    Object.keys(itemsCache).forEach((k) => delete itemsCache[k])
  }
}

export default loadMasterOptions
